/**
 * هر متنی که به کاربر نشان داده می‌شود باید فارسی باشد.
 * پیام‌های سرور یا مرورگر گاهی انگلیسی‌اند (مثل «Your session is invalid or has expired.»).
 * این تابع اگر متن فارسی نبود، یک متن فارسیِ مناسب جایش می‌گذارد.
 */

const PERSIAN_LETTER = /[؀-ۿ]/;
const LATIN_LETTER = /[A-Za-z]/;

export const USER_MESSAGES = {
  401: "نشست شما تمام شده. دوباره وارد شوید.",
  403: "اجازه‌ی این کار را ندارید.",
  404: "پیدا نشد. ممکن است حذف شده باشد.",
  413: "حجم فایل زیاد است. فایل کوچک‌تری بفرستید.",
  429: "درخواست‌ها زیاد شد. چند لحظه بعد دوباره امتحان کنید.",
  500: "مشکلی پیش آمد. چند لحظه بعد دوباره امتحان کنید.",
  network: "اتصال برقرار نشد. اینترنت را بررسی کنید و دوباره امتحان کنید.",
  default: "مشکلی پیش آمد. دوباره امتحان کنید.",
};

/** متن فارسی است یا حداقل حرف لاتین ندارد (مثلاً فقط عدد). */
export function isUserFacingText(text) {
  if (typeof text !== "string") return false;
  const t = text.trim();
  if (!t) return false;
  return PERSIAN_LETTER.test(t) || !LATIN_LETTER.test(t);
}

function statusFromText(text) {
  const t = String(text || "").toLowerCase();
  if (!t) return null;
  if (/session|unauthori[sz]ed|unauthenticated|token|expired|not logged|login required|authentication/.test(t)) return 401;
  if (/forbidden|permission|not allowed|access denied|not authori[sz]ed/.test(t)) return 403;
  if (/too large|payload|file size|limit_file_size|entity too/.test(t)) return 413;
  if (/too many|rate limit/.test(t)) return 429;
  if (/not found|no such/.test(t)) return 404;
  if (/network|failed to fetch|load failed|timeout|timed out|offline|econn|socket/.test(t)) return "network";
  return null;
}

/** متن پیش‌فرض فارسی بر اساس کد وضعیت HTTP. */
export function messageForStatus(status) {
  const n = Number(status);
  if (status === "network" || status === 0) return USER_MESSAGES.network;
  if (USER_MESSAGES[n]) return USER_MESSAGES[n];
  if (n >= 500) return USER_MESSAGES[500];
  return USER_MESSAGES.default;
}

/**
 * @param {unknown} raw - پیام خام (از سرور، خطای JS یا هر جای دیگر)
 * @param {string} [fallback] - متن فارسیِ مخصوص همان کار، اگر پیام خام فارسی نبود
 * @param {number|string} [status] - کد وضعیت HTTP، اگر معلوم است
 * @returns {string}
 */
export function toUserMessage(raw, fallback, status) {
  if (isUserFacingText(raw)) return raw.trim();
  const guessed = status ?? statusFromText(raw);
  // این چند حالت از متن اختصاصی هم مهم‌ترند، چون کاربر باید بداند چه کند.
  if ([401, 413, 429, "network"].includes(guessed)) return messageForStatus(guessed);
  if (isUserFacingText(fallback)) return fallback.trim();
  if (guessed != null) return messageForStatus(guessed);
  return USER_MESSAGES.default;
}
